import type { Tool } from './types';
import { documentTools } from '@/tools/documents';
import { imageTools } from '@/tools/images';
import { textTools } from '@/tools/text';
import { colorTools } from '@/tools/color';
import { calculatorTools } from '@/tools/calculators';
import { converterTools } from '@/tools/converters';
import { dataTools } from '@/tools/data';
import { tinyTools } from '@/tools/tiny';
import { securityTools } from '@/tools/security';
import { writingTools } from '@/tools/writing';
import { operationsTools } from '@/tools/operations';
import { browserTools } from '@/tools/browser';

export const TOOLS: Tool[] = [
  ...documentTools,
  ...imageTools,
  ...converterTools,
  ...dataTools,
  ...textTools,
  ...colorTools,
  ...calculatorTools,
  ...tinyTools,
  ...securityTools,
  ...writingTools,
  ...operationsTools,
  ...browserTools,
];

export const TOOLS_BY_ID = Object.fromEntries(TOOLS.map((t) => [t.id, t])) as Record<string, Tool>;

export const TOOLS_BY_CATEGORY: Record<string, Tool[]> = TOOLS.reduce(
  (acc, t) => {
    (acc[t.category] ??= []).push(t);
    return acc;
  },
  {} as Record<string, Tool[]>,
);

export function findToolById(id: string): Tool | undefined {
  return TOOLS_BY_ID[id];
}

export * from './types';
export * from './categories';
